import { useTranslation } from 'react-i18next';
import Layout from "../../../shared/Layout";
import './NotFoundPage.scss';
import {Box, Button, Container, Typography} from "@mui/material";
import error404 from '../../../assets/errors/error-404.png';

export const NotFoundPage = () => {
    const { t } = useTranslation();
    return (
        <Layout>
            <>
                <Box
                    component="main"
                    sx={{
                        alignItems: 'center',
                        display: 'flex',
                        flexGrow: 1,
                        py: '80px'
                    }}
                >
                    <Container maxWidth="lg">
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                mb: 6
                            }}
                        >
                            <Box
                                alt="Not found"
                                component="img"
                                src={error404}
                                sx={{
                                    width: '150px',
                                    height: 'auto'
                                }}
                            />
                        </Box>
                        <Typography
                            align="center"
                            variant={'h4'}
                        >
                            {t('404: Страницы, которую вы ищете, здесь нет.')}
                        </Typography>
                        <Typography
                            align="center"
                            color="text.secondary"
                            sx={{ mt: 0.5 }}
                        >
                            {t('Мы не можем найти страницу, которую вы ищете.')}
                        </Typography>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                mt: 6
                            }}
                        >
                            <Button
                                onClick={() => window.history.back()}
                                variant="outlined"
                            >
                                {t('Вернуться обратно')}
                            </Button>
                        </Box>
                    </Container>
                </Box>
            </>
        </Layout>
    );
};
